var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 21.9292C6.96156 21.9292 2.85156 17.8292 2.85156 12.7792V10.8992C2.85156 10.5092 3.17156 10.1992 3.55156 10.1992C3.93156 10.1992 4.25156 10.5192 4.25156 10.8992V12.7792C4.25156 17.0492 7.72156 20.5192 11.9916 20.5192C16.2616 20.5192 19.7316 17.0492 19.7316 12.7792V10.8992C19.7316 10.5092 20.0516 10.1992 20.4316 10.1992C20.8116 10.1992 21.1316 10.5192 21.1316 10.8992V12.7792C21.1516 17.8292 17.0416 21.9292 12.0016 21.9292Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 2C8.63844 2 5.89844 4.74 5.89844 8.1V12.79C5.89844 16.15 8.63844 18.89 11.9984 18.89C15.3584 18.89 18.0984 16.15 18.0984 12.79V8.1C18.0984 4.74 15.3584 2 11.9984 2ZM14.1784 10.59C14.1084 10.86 13.8584 11.04 13.5884 11.04C13.5384 11.04 13.4784 11.03 13.4284 11.02C12.4084 10.74 11.3284 10.74 10.3084 11.02C9.97844 11.11 9.64844 10.92 9.55844 10.59C9.46844 10.27 9.65844 9.93 9.98844 9.84C11.2184 9.5 12.5184 9.5 13.7484 9.84C14.0784 9.93 14.2684 10.26 14.1784 10.59ZM15.0284 7.82C14.9384 8.07 14.7084 8.22 14.4584 8.22C14.3884 8.22 14.3184 8.21 14.2484 8.18C12.7184 7.62 11.0384 7.62 9.50844 8.18C9.18844 8.3 8.83844 8.14 8.71844 7.82C8.60844 7.51 8.76844 7.16 9.08844 7.04C10.8884 6.39 12.8684 6.39 14.6584 7.04C14.9784 7.16 15.1384 7.51 15.0284 7.82Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.4f340bbcccce9baa545ce2a95b5e8cb0.svg";
export { ForwardRef as ReactComponent };